import { useCallback } from 'react'
import { useStores } from 'stores/utils/hooks/useStores'
import {
  broadcastToParent,
  RegisteredEventName
} from '@finanzcheck/catalyst-pollard'

const MORTGAGE_REDIRECT_URL_HOST = 'https://baufi.smava.de/'

export const useMortgageRedirect = () => {
  const { traversal, navigation } = useStores()

  const getMortgageRedirectUrl = useCallback(() => {
    if (!navigation.parentUrl) {
      return MORTGAGE_REDIRECT_URL_HOST
    }

    const url = new URL(navigation.parentUrl)
    const searchParams = new URLSearchParams(url.search)

    // Remove params that will be replaced with Taurine values
    searchParams.delete('amount')
    searchParams.delete('category')
    searchParams.delete('duration')
    searchParams.delete('term')
    searchParams.delete('purpose')

    return `${MORTGAGE_REDIRECT_URL_HOST}?amount=${traversal.data.common.amount}&category=${traversal.data.common.purpose}&duration=${traversal.data.common.term}&${searchParams.toString()}`
  }, [traversal.data, navigation.parentUrl])

  const redirectToMortgage = useCallback(() => {
    broadcastToParent({
      eventName: RegisteredEventName.redirect,
      data: { url: getMortgageRedirectUrl() }
    })
  }, [getMortgageRedirectUrl])

  return { redirectToMortgage }
}
